import PageTypeFactory from '../../../page/get_page_type';
import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

export const backToFirstLevel = () => {
    const category = GA_EVENTS.navigation.category;
    const action = GA_EVENTS.navigation.actions.backToFirstLevel;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({
        category,
        action,
        label,
    });
};
